// Noon nav dropdowns - JS positioned to escape overflow clipping
document.addEventListener('DOMContentLoaded', function() {
  /* v4.1: Title Case now handled by CSS text-transform (no FOUC flash).
     JS toTitleCase removed. See noon.css for .noon-catnav-item > a etc. */

  document.querySelectorAll('.noon-catnav-item.has-dropdown').forEach(function(item) {
    var dropdown = item.querySelector('.noon-catnav-dropdown');
    if (!dropdown) return;
    
    // Move dropdown to body to escape overflow clipping
    document.body.appendChild(dropdown);
    dropdown.style.position = 'fixed';
    dropdown.style.display = 'none';
    dropdown.style.zIndex = '9999';
    
    var showTimer, hideTimer;
    
    item.addEventListener('mouseenter', function() {
      clearTimeout(hideTimer);
      showTimer = setTimeout(function() {
        var rect = item.getBoundingClientRect();
        dropdown.style.left = rect.left + 'px';
        dropdown.style.top = (rect.bottom + 4) + 'px';
        dropdown.style.display = 'block';
      }, 100);
    });
    
    item.addEventListener('mouseleave', function() {
      clearTimeout(showTimer);
      hideTimer = setTimeout(function() {
        dropdown.style.display = 'none';
      }, 200);
    });
    
    dropdown.addEventListener('mouseenter', function() {
      clearTimeout(hideTimer);
    });
    
    dropdown.addEventListener('mouseleave', function() {
      hideTimer = setTimeout(function() {
        dropdown.style.display = 'none';
      }, 200);
    });
  });
});
/* v4.3: cap sidebar height to right-column height */
(function () {
  function fitNoonSidebar() {
    var side = document.querySelector('.noon-sidebar');
    if (!side) return;
    var flex = side.closest('.noon-home-flex');
    var main = flex ? flex.querySelector('.noon-home-main') : null;
    if (!main || window.innerWidth < 990) { side.style.maxHeight = ''; return; }
    side.style.maxHeight = main.offsetHeight + 'px';
  }
  window.addEventListener('load', fitNoonSidebar);
  window.addEventListener('resize', fitNoonSidebar);
  if ('ResizeObserver' in window) {
    var m = document.querySelector('.noon-home-flex .noon-home-main');
    if (m) new ResizeObserver(fitNoonSidebar).observe(m);
  }
})();